var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"ga-click-outside",rawName:"v-ga-click-outside",value:(_vm.hidePopover),expression:"hidePopover"},{name:"tooltip",rawName:"v-tooltip",value:({
    show: _vm.isActive,
    content: ("<a id='" + _vm.linkId + "' href='" + _vm.href + "' target='_blank'>" + _vm.href + "</a>"),
    trigger: 'manual',
    placement: 'bottom-start',
    classes: 'tooltip editor visit-link',
    boundariesElement: _vm.boundaryElement,
  }),expression:"{\n    show: isActive,\n    content: `<a id='${linkId}' href='${href}' target='_blank'>${href}</a>`,\n    trigger: 'manual',\n    placement: 'bottom-start',\n    classes: 'tooltip editor visit-link',\n    boundariesElement: boundaryElement,\n  }"}],ref:"content",attrs:{"href":_vm.href},on:{"click":function($event){_vm.isActive = true}}})}
var staticRenderFns = []

export { render, staticRenderFns }